import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setCache,getCache,clearCache } from '@/utils/cache'
import { setScopedToken, removeScopedToken } from '@/utils/authScope'

const user = {
  state: {
    token: getToken(),
    userId: '',
    userName: '',
    userMobile: '',
    createPermission: '',
    exportPermission: '',
    customerManagePermission: '',
    customerAuditPermission: '',
    superUser: '',
    superQueryUser: '',
    userFactory: '',
    showTabbar: false,
    name: '',
    idCard: '',
    phone: '',
    userType: '',
    viewPermission: '',
    auditPermission: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      // 写入当前系统+终端的 token（从当前路由解析 scope）
      setScopedToken(token)
      console.log('Scoped Token set in mutation:', token);
    },
    // 可选：如果有清理 token 的 mutation/action，也同步清理 scoped token
    RESET_TOKEN: (state) => {
      state.token = ''
      removeScopedToken()
      removeToken()
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_USERNAME: (state, userName) => {
      state.userName = userName
    },
    SET_USERMOBILE: (state, userMobile) => {
      state.userMobile = userMobile
    },
    SET_CREATEPERMISSION: (state, createPermission) => {
      state.createPermission = createPermission
    },
    SET_EXPORTPERMISSION: (state, exportPermission) => {
      state.exportPermission = exportPermission
    },
    SET_SUPERUSER: (state, superUser) => {
      state.superUser = superUser
    },
    SET_SUPERQUERYUSER: (state, superQueryUser) => {
      state.superQueryUser = superQueryUser
    },
    SET_USERFACTORY: (state, userFactory) => {
      state.userFactory = userFactory
    },
    SET_SHOWTABBAR: (state, showTabbar) => {
      state.showTabbar = showTabbar
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_IDCARD: (state, idCard) => {
      state.idCard = idCard
    },
    SET_USERTYPE: (state, userType) => {
      state.userType = userType
    },
    SET_VIEWPERMISSION: (state, viewPermission) => {
      state.viewPermission = viewPermission
    },
    SET_AUDITPERMISSION: (state, auditPermission) => {
      state.auditPermission = auditPermission
    },
    SET_CUSTOMERMANAGEPERMISSION: (state, customerManagePermission) => {
      state.customerManagePermission = customerManagePermission
    },
    SET_CUSTOMERAUDITPERMISSION: (state, customerAuditPermission) => {
      state.customerAuditPermission = customerAuditPermission
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          if(res){
            // 先清空再设置
            removeToken()
            clearCache('user_id');
            clearCache('user_name');
            clearCache('user_phone');
            clearCache('user_idCard');
            clearCache('user_factory');
            clearCache('user_type');
            clearCache('system_type');
            clearCache('user_view_permission');
            clearCache('user_create_permission');
            clearCache('user_audit_permission');
            clearCache('user_export_permission');
            clearCache('super_user');
            clearCache('super_query_user');
            clearCache('show_linye_tabbar');
            clearCache('show_linye_manage_tabbar');
            clearCache('show_linye_customer_tabbar');
            clearCache('show_logistics_tabbar');
            clearCache('show_logistics_user_tabbar');
            clearCache('show_logistics_manage_tabbar');
            clearCache('show_logistics_customer_tabbar');
            clearCache('show_logistics_flConfig_tabbar');
            clearCache('show_system_config_tabbar');
            clearCache('show_grading_criteria_config_tabbar');
            clearCache('show_conversion_fraction_config_tabbar');
            clearCache('show_interest_rate_config_tabbar');
            clearCache('supplier_mdm_disable');
            clearCache('show_tabbar');
            clearCache('show_super_user_tabbar');
            clearCache('show_customer_tabbar');
            clearCache('show_user_simple_register_tabbar');

            // 重新设置
            setToken(res.data.token)
            setCache('user_id', res.data.userId);
            setCache('user_name', res.data.name);
            setCache('user_phone', res.data.phone);
            setCache('user_idCard', res.data.idCard);
            setCache('user_factory', res.data.userFactory);
            setCache('user_type', res.data.userType);
            setCache('user_view_permission', res.data.viewPermission);
            setCache('user_create_permission', res.data.createPermission);
            setCache('user_audit_permission', res.data.auditPermission);
            setCache('user_export_permission', res.data.exportPermission);
            setCache('super_user', res.data.superUser);
            setCache('super_query_user', res.data.superQueryUser);
            setCache('system_type', res.data.systemType);

            if(res.data.systemType === 1){  // 林业竞拍系统
              if(res.data.superUser){
                setCache('show_linye_manage_tabbar', true);
                setCache('show_linye_customer_tabbar', true);
              } else {
                if(res.data.customerManagePermission){
                  setCache('show_linye_customer_tabbar', true);
                  setCache('show_linye_tabbar', true);
                }
              }
            } else if(res.data.systemType === 2){  // 物流招标系统
              if(res.data.superUser){
                setCache('show_logistics_user_tabbar', true);
                setCache('show_logistics_tabbar', true);
                setCache('show_logistics_customer_tabbar', true);
              } else {
                if(res.data.customerManagePermission){
                  setCache('show_logistics_customer_tabbar', true);
                  setCache('show_logistics_tabbar', true);
                }
                if(res.data.factoryLineConfigPermission){
                  setCache('show_logistics_flConfig_tabbar', true);
                  setCache('show_logistics_tabbar', true);
                }
                if(res.data.systemConfigPermission){
                  setCache('show_system_config_tabbar', true);
                  setCache('show_logistics_tabbar', true);
                }
                if(res.data.gradingCriteriaConfigPermission){
                  setCache('show_grading_criteria_config_tabbar', true);
                  setCache('show_logistics_tabbar', true);
                }
                if(res.data.conversionFractionConfigPermission){
                  setCache('show_conversion_fraction_config_tabbar', true);
                  setCache('show_logistics_tabbar', true);
                }
                if(res.data.interestRateConfigPermission){
                  setCache('show_interest_rate_config_tabbar', true);
                  setCache('show_logistics_tabbar', true);
                }
              }
            } else if(res.data.systemType === 0){ // 采购招标系统。
              setCache('show_tabbar', true);
              // 招标端
              if(res.data.superUser){
                setCache('show_super_user_tabbar', true);
                setCache('show_interest_rate_config_tabbar', true);
              }
              if(res.data.superUser || res.data.userType === 2  || res.data.userType === 6){ // 招标端普通用户、特殊用户
                if(res.data.customerManagePermission){
                  setCache('show_customer_tabbar', true);
                }
                if(res.data.userSimpleRegisterPermission){ // 简易注册权限
                   // 显示简易注册菜单
                  setCache('show_user_simple_register_tabbar', true);
                }
              }
              if(res.data.userType === 3 || res.data.userType === 4){ // 投标端用户
                 // 显示投标端菜单
                setCache('show_cg_tendering_tabbar', true);
                setCache('supplier_mdm_disable', res.data.isPass); // 控制是否可以登录
              }
            }
            console.log('Login successful:', res.data);
            
            commit('SET_TOKEN', res.data.token)
            console.log(res.data.token)
            // commit('SET_USERID', res.data.userId)
            // commit('SET_NAME', res.data.name)
            // commit('SET_PHONE', res.data.phone)
            // commit('SET_IDCARD', res.data.idCard)
            // commit('SET_USERTYPE', res.data.userType)
            // commit('SET_VIEWPERMISSION', res.data.viewPermission)
            // commit('SET_SUPERUSER', res.data.superUser)
            // commit('SET_CREATEPERMISSION', res.data.createPermission)
            // if(res.data.superUser){
            //   commit('SET_SHOWTABBAR', true)
            // }
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    // GetInfo ({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     getInfo().then(res => {
    //       const user = res.user
    //       if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
    //         commit('SET_ROLES', res.roles)
    //         commit('SET_PERMISSIONS', res.permissions)
    //       } else {
    //         commit('SET_ROLES', ['ROLE_DEFAULT'])
    //       }
    //       let avatar = res?.student?.avatar || user.avatar || ''
    //       if (avatar && avatar != '') {
    //         avatar = process.env.VUE_APP_BASE_API + avatar
    //       }
    //       commit('SET_AVATAR', avatar)
    //       commit('SET_NAME', user.userName)
    //       commit('SET_STUDENTID', user.studentId)
    //       commit('SET_SCHOOLNO', res?.student?.schoolNo)
    //       commit('SET_NICKNAME', user.nickName)
    //       commit('SET_ISENTRYRESULTSUSER', res?.student?.isEntryResultsUser || 0)
    //       resolve(res)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 退出系统 清除缓存
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          removeToken()
          localStorage.clear()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
